import { Component, ElementRef, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import SignaturePad from 'signature_pad';


@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements OnInit, AfterViewInit {

  @ViewChild('signatureCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;
  public showDraw = 'Draw by Finger';
  inputText = '';
  constructor() {}


  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.canvasRef) {
      this.signaturePad = new SignaturePad(this.canvasRef.nativeElement);
    } else {
      console.error('El canvas no está definido');
    }
  }

  segmentChanged(ev: any) {
    this.showDraw = ev.detail.value;
  }
}
